class lookups {
    constructor(
          name) {
        this.id = name;
        this.text = name;
        
    }
    static fromJson({
          name
    }) {
        return new lookups(
          name
        );
    }
}
export default lookups;
